import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

// @ts-ignore
import deleteIcon from '!!raw-loader?!@atlas-workspace/shared/assets/lib/basket-white.svg';

//TODO this component needs to be refactored, I think.
// Make it flexible to avoid changing the component for each new button.
@Component({
  selector: 'atl-delete-modal',
  templateUrl: './delete-modal.component.html',
  styleUrls: ['./delete-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteModalComponent implements OnChanges {
  @Input() showInvite = false;
  @Input() showDownloadQR = false;
  @Input() useDownloadQrIcon = false;
  @Input() useDownloadQrText = 'Button.Download_Options_QR_codes';
  @Input() showTransfer = false;
  @Input() showDelete = true;
  @Input() disabledTransferTooltips = false;
  @Input() disabledDownloadTooltips = false;
  @Input() showMoveIn = false;
  @Input() showDownload = false;
  @Input() deleteTooltip = 'Shared.Button.Delete';
  @Input() showMarkRead = false;
  @Input() showRename = false;
  @Input() showSelectAll = false;
  @Input() publishUnpublish = false;
  @Input() showMoreDropdown = false;
  @Input() showSendNewsletter = false;
  @Input() showPin = false;
  @Input() fdvAdvance = false;
  @Input() pinTooltip = '';
  @Input() showConnectUnits = false;
  @Input() publishText = 'Button.Publish';
  @Input() showChangeStatus = false;
  @Input() isChangeStatusActive = false;
  @Output() passChangeStatus: EventEmitter<boolean> = new EventEmitter();

  @Output() passCancel: EventEmitter<boolean> = new EventEmitter();
  @Output() passDelete: EventEmitter<boolean> = new EventEmitter();
  @Output() passSendInvite: EventEmitter<boolean> = new EventEmitter();
  @Output() passDownloadQR: EventEmitter<boolean> = new EventEmitter();
  @Output() passMoveIn: EventEmitter<boolean> = new EventEmitter();
  @Output() passDownload: EventEmitter<boolean> = new EventEmitter();
  @Output() passTransfer: EventEmitter<boolean> = new EventEmitter();
  @Output() passRead: EventEmitter<boolean> = new EventEmitter();
  @Output() passRename: EventEmitter<boolean> = new EventEmitter();
  @Output() passPublishUnpublish: EventEmitter<boolean> = new EventEmitter();
  @Output() passSelectAll: EventEmitter<boolean> = new EventEmitter();
  @Output() passSendNewsletter: EventEmitter<boolean> = new EventEmitter();
  @Output() passSendTemplateNewsletter: EventEmitter<boolean> = new EventEmitter();
  @Output() passPin: EventEmitter<boolean> = new EventEmitter();
  @Output() passConnectUnits: EventEmitter<void> = new EventEmitter();
  @Output() passApprove: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() passDecline: EventEmitter<boolean> = new EventEmitter<boolean>();

  public expandedTransfer = false;
  public expandedDownload = false;
  public expandedSendNewsletter = false;

  public deleteIcon = deleteIcon;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.disabledTransferTooltips) {
      this.disabledTransferTooltips = changes.disabledTransferTooltips.currentValue;
    }
    if (changes.disabledDownloadTooltips) {
      this.disabledDownloadTooltips = changes.disabledDownloadTooltips.currentValue;
    }
  }

  public confirm(): void {
    this.passDelete.emit(true);
  }

  public cancel(): void {
    this.passCancel.emit(true);
  }

  public sendInvite(): void {
    this.passSendInvite.emit(true);
  }
  public downloadQR(): void {
    this.passDownloadQR.emit(true);
  }

  public connectUnits():void {
    this.passConnectUnits.emit();
  }

  public publishUnpublishHandler(): void {
    this.passPublishUnpublish.emit(true);
  }

  public selectAll(): void {
    this.passSelectAll.emit(true);
  }

  public approve(): void {
    this.passApprove.emit(true);
  }

  public decline(): void {
    this.passDecline.emit(true);
  }

  public transfer(val: boolean): void {
    if (val && this.expandedDownload) this.expandedDownload = false;
    this.expandedTransfer = !this.expandedTransfer;
    this.passTransfer.emit(!val ? val : this.expandedTransfer);
  }

  changeStatus(): void {
    this.passChangeStatus.emit();
  }

  public moveIn(): void {
    this.passMoveIn.emit(true);
  }

  public download(val: boolean): void {
    if (val && this.expandedTransfer) this.expandedTransfer = false;
    this.expandedDownload = !this.expandedDownload;

    this.passDownload.emit(!val ? val : this.expandedDownload);
  }

  public read(): void {
    this.passRead.emit(true);
  }

  public rename(): void {
    this.passRename.emit(true);
  }

  public pin(): void {
    this.passPin.emit(true);
  }

  public closeAllPopups(): void {
    this.expandedDownload = false;
    this.expandedTransfer = false;
  }

  public toggleSendNewsletterDropdown(expanded: boolean, e: Event): void {
    e.preventDefault();
    e.stopImmediatePropagation();
    this.expandedSendNewsletter = expanded;
  }
}
